module.exports = __webpack_public_path__ + "static/media/Heebo-Bold.30dd4093.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/avesco/Heebo-Bold.woff2
// module id = 783
// module chunks = 0